var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackToTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "back-to-top",
    d: "M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.994 27.95V16.065L12.238 21.1a.927.927 0 01-.709.326c-.274 0-.515-.097-.72-.291a.94.94 0 01-.309-.711c0-.28.091-.528.274-.746l6.494-6.85a.94.94 0 01.72-.327.94.94 0 01.72.326l6.518 6.898c.183.202.274.435.274.699a.986.986 0 01-.32.746.92.92 0 01-.709.29 1 1 0 01-.709-.314l-4.756-5.033v11.861c0 .264-.091.497-.274.7a.962.962 0 01-1.418.035 1.024 1.024 0 01-.32-.758zM10.5 10a1 1 0 011-1h13a1 1 0 010 2h-13a1 1 0 01-1-1z"
  })));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/back-to-top.svg";
export { SvgBackToTop as ReactComponent };